import { inject } from '@angular/core';
import { Auth, user } from '@fido/firebase/auth';
import { doc, Firestore, getDocFromServer } from '@fido/firebase/firestore';
import { CanActivateFn, Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { firstValueFrom } from 'rxjs';
import { appUserConverter } from '../../auth/data/app-user';

/**
 * Guard that ensures user does NOT have an organization.
 * If user is not authenticated, redirects to sign-in.
 * If user has an organization, redirects to their workspace.
 * This is used for the create-organization page.
 */
export const noOrgRequiredGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const firestore = inject(Firestore);
  const auth = inject(Auth);

  const u = await firstValueFrom(user(auth));

  if (!u) return router.createUrlTree(['/sign-in']);

  const userDoc = await getDocFromServer(
    doc(firestore, 'users', u.uid).withConverter(appUserConverter),
  );
  const data = userDoc.data();
  const organizationId = data?.organizationId;
  if (organizationId) {
    notify('You are already a member of an organization.', 'warning', 3000);
    return router.createUrlTree(['/']);
  }
  return true;
};
